import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class CustomCookieService {

    constructor(private cookieService: CookieService){

    }

    getCookieData(key):string{
        return this.cookieService.get(key);
    }

    setCookieData(key, value){
        this.cookieService.set(key, value);
    }
    removieCokkieData(){
        this.cookieService.deleteAll()
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/mycookie.service.ts